import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useGetMarketTrends = (local) => {
  const client = useApi();

  return useQuery(['get-market-trends'], () => client.get(`/marketTrends/user/list/${local}`).then((res) => res.data), {
    retryOnMount: false,
  });
};
